<template>
    <v-hover v-slot:default="{ hover }">
        <v-card
            class="eatery-card mx-auto pa-0"
            :class="{ 'active': hover }"
            :href="eatery.url"
            target="_blank"
            elevation="0"
            rounded="xl"
        >
            <v-img
                eager
                :src="getImageUrl(eatery.image)"
                :alt="eatery.title"
                class="eatery-image"
            ></v-img>

            <v-card-title class="eatery-title">{{ eatery.title }}</v-card-title>

            <v-card-text class="text-left">
                <p class="eatery-text"> {{ eatery.content }}</p>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
import { getMediaPathUrl } from '@/utils/helpers';

export default {
    name: "EateryCard",

    props: {
        eatery: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getImageUrl(image) {
            try {
                return getMediaPathUrl(image);
            } catch (thrown) {
                return '';
            }
        },
    },
}
</script>

<style scoped>
/** Eatery Card styles */
.eatery-card {
    transition: 0.3s all ease-in-out;
    background-color: #fff;
    height: 100%;
}

.eatery-card.active {
    background-color: #2d76e3;
}

.eatery-card .eatery-image>>>.v-image__image {
    transition: 0.3s all ease-in-out;
}

.eatery-card.active .eatery-image>>>.v-image__image {
    transform: scale(1.1);
}

.eatery-card .eatery-title {
    color: #000;
    font-size: 20px;
    font-weight: bold;
}

.eatery-card.active .eatery-title {
    color: #fff;
}

.eatery-card .eatery-text {
    font-size: 16px;
    padding-bottom: 6px;
}

.eatery-card.active .eatery-text {
    color: #fff;
}
</style>
